const add0 = t => (String(t).padStart(2, '0'));

/**
 * @param {HTMLInputElement|null} inputElement
 * @param {String} time
 * @param {Number} index
 *
 * @return {String}
 */
export function extractSolrDateFromFlatPickerInput(inputElement, time = '0000', index = 0) {
  if (inputElement === null) {
    return '';
  }
  if (Object.prototype.hasOwnProperty.call(inputElement, '_flatpickr') === false) {
    return '';
  }

  if (inputElement._flatpickr.selectedDates.length === 0) {
    return '';
  }

  /** @type {Date} */
  const date = inputElement._flatpickr.selectedDates[index];

  return `${date.getFullYear()}${add0(date.getMonth() + 1)}${add0(date.getDate())}${time}`;
}

/**
 * @param {String} mysqlDate
 *
 * @return {Date|null}
 */
export function dateFromMysqlDate(mysqlDate) {
  if (mysqlDate === '') {
    return null;
  }

  const [year, month, day] = [...mysqlDate.split('-')];

  return new Date(year, (month - 1), day);
}
